import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { OssService } from '../../service/oss/oss.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { OrangeOssService } from '../../service/orange-oss/orange-oss.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.less'],
})
export class FileUploadComponent implements OnInit {
  @Output() newItemEvent = new EventEmitter<string>();
  isVisibleMiddle = false;
  addNewItem(value: string): void {
    this.newItemEvent.emit(value);
  }
  selectFile(event: any, type: number): void {
    console.log(event);
    if (event.target.files.length != 0) {
      const file = event.target.files[0];
      this.isVisibleMiddle = true;
      this.orangeOssService.fileUpload(file, type).then((value) => {
        console.log(value);
        this.isVisibleMiddle = false;
        if (value.status == 1) {
          const data = JSON.stringify(value);
          this.addNewItem(data);
          console.log('发射文件上传成功事件');
        } else {
          console.log('文件上传失败');
        }
      });
    }
  }

  constructor(private orangeOssService: OrangeOssService) {}

  ngOnInit(): void {}
}
